import auth from '../auth/router';
import records from '../records/router';
import admin from '../admin/router';
import Home from '../components/Home';
import patientRecords from '../patient-records/router';

const app = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      authenticate: true
    }
  },
];

export default [...app, ...auth, ...records, ...admin, ...patientRecords];
